import { PAGE_SIZE } from "../../../../constants/Config";
import {
    BRAND_DELETE,
    BRAND_DETAIL,
    BRAND_INSERT,
    BRAND_LIST,
    BRAND_UPDATE,
    BRAND_GETALL
} from "./action-types";


const initialState = {
    data: [],
    totalRows: 0,
    currentPage: 0,
    pageSize: PAGE_SIZE,
    items: [],
    item: null,
    suggestion: []
}

const reducer = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case BRAND_LIST:
            return list(state, payload)
        case BRAND_DETAIL:
            return detail(state, payload)
        case BRAND_UPDATE:
            return update(state, payload)
        case BRAND_INSERT:
            return insert(state, payload)
        case BRAND_DELETE:
            return deletes(state, payload)
        case BRAND_GETALL:
            return suggestion(state, payload)
        default:
            return state
    }
}

function list(state, payload) {
    state = Object.assign({}, state, payload)
    return state
}
function suggestion(state, payload) {
    state = Object.assign({}, state, {
        suggestion: payload
    })
    return state;
}
function detail(state, payload) {
    state = Object.assign({}, state, {
        item: payload
    })
    return state
}

function deletes(state, payload) {
    const data = state.data.filter(obj => obj.id !== payload)

    return Object.assign({}, state, { data })
}

function update(state, payload) {
    const data = state.data.map(obj => {
        if (obj.id === payload.id) {
            return { ...obj, ...payload }
        }
        return obj
    })

    return Object.assign({}, state, { data })
}

function insert(state, payload) {
    const data = [...state.data, payload]
    return Object.assign({}, state, { data })
}


export default reducer
